import styles from '../../styles/modules/Footer.module.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className="container">
        <div className={styles.footerContent}>
          <div className={styles.brand}>
            <div className={styles.logo}>
              <span className={styles.logoText}>devTools</span>
              <span className={styles.logoDot}>.</span>
            </div>
            <p className={styles.tagline}>
              A comprehensive collection of developer utilities. Fast, secure, and always available.
            </p>
            <a href="https://lab39.org" className={styles.backToLab39}>
              ← Back to lab39
            </a>
          </div>

          <div className={styles.links}>
            <div className={styles.linkGroup}>
              <h4 className={styles.linkTitle}>Categories</h4>
              <a href="/#formatters" className={styles.link}>Formatters</a>
              <a href="/#encoders" className={styles.link}>Encoders</a>
              <a href="/#generators" className={styles.link}>Generators</a>
              <a href="/#converters" className={styles.link}>Converters</a>
            </div>
            
            <div className={styles.linkGroup}>
              <h4 className={styles.linkTitle}>Resources</h4>
              <span className={styles.linkDisabled}>About</span>
              <span className={styles.linkDisabled}>Privacy Policy</span>
              <span className={styles.linkDisabled}>Terms</span>
              <span className={styles.linkDisabled}>Contact</span>
            </div>
          </div>
        </div>

        <div className={styles.footerBottom}>
          <p className={styles.copyright}>
            © {currentYear} devTools · Part of lab39
          </p>
          <p className={styles.made}>
            Made with ❤️ for developers
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;